import { useTransition } from '@react-spring/web';
import PropTypes from 'prop-types';

var Transition = function Transition(_ref) {
  var children = _ref.children,
      open = _ref.open,
      config = _ref.config;
  var transition = useTransition(open, config);
  return transition(function (interpolation, item) {
    return item ? children(interpolation) : null;
  });
};

Transition.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  open: PropTypes.bool.isRequired,
  config: PropTypes.shape({
    from: PropTypes.object,
    enter: PropTypes.object.isRequired,
    leave: PropTypes.object,
    config: PropTypes.object
  }).isRequired
};
export { Transition };